import './AgePage.css';

import AgeLogo from './../../image/logo.svg';
import AgeImage from './../../image/image-1.jpg';
import axios from 'axios';

const AgePage = ({ setCurrentPage, setIsUserHavePlace, setTableId }) => {
    const handleTrueClick = async () => {
        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                console.error('Токен отсутствует');
                return;
            } else {
                console.log('Токен: ', authToken);
            }

            const response = await axios.get(
                'https://apihpwild.ru/user/set/legal',
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            if (response.data.success) {
                try {
                    const tableResponse = await axios.get(
                        'https://apihpwild.ru/rest/user/table',
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem(
                                    'authToken'
                                )}`,
                            },
                        }
                    );

                    if (tableResponse.data.success) {
                        // setIsUserHavePlace(tableResponse.data.result);
                        setTableId(tableResponse.data.result);
                        setCurrentPage('MainPage');
                    }
                } catch (tableError) {
                    console.error('Ошибка проверки столика:', tableError);
                }
            }
        } catch (error) {
            console.error('Ошибка подтверждения возраста ', error);
        }
    };

    const handleFalseClick = () => {
        setCurrentPage('NoAccessPage');
    };

    return (
        <div className='age__wrapper'>
            <div className='age__logo'>
                <img src={AgeLogo} alt='Logo' />
            </div>
            <div className='age__image'>
                <img src={AgeImage} />
            </div>

            <div className='age__btn_items'>
                <h3 className='age__btn_title'>Вам исполнилось 18 лет?</h3>
                <button className='age__btn' onClick={handleTrueClick}>
                    Да, мне есть 18 лет
                </button>
                <button
                    className='age__btn age__btn_not'
                    onClick={handleFalseClick}
                >
                    Нет
                </button>
            </div>
        </div>
    );
};

export default AgePage;
